import { useCallback, useMemo } from 'react';
import NotificationComponent from '@stripcash/ui-kit/components/Notification';

import { useT } from 'common/i18n';
import { Notification } from 'types/notification';

type TranslatedNotificationProps = Notification & {
  onHide: (data: { id: string }) => void;
};

const TranslatedNotification = ({
  message,
  id,
  type,
  onHide,
  withTranslation = false,
  translationOptions: { tElements = {}, elements = {} } = {},
}: TranslatedNotificationProps) => {
  const t = useT('');
  const handleHide = useCallback(() => {
    onHide({ id });
  }, [id, onHide]);

  const translatedTitle = useMemo(() => {
    if (withTranslation) {
      const preparedTranslationElements = Object.entries(tElements).reduce(
        (acc, [key, value]) => ({ ...acc, [key]: () => t(value as string) }),
        {},
      );

      return t(message, {
        elements: {
          ...preparedTranslationElements,
          ...elements,
        },
      });
    }

    return message;
  }, [message, elements, t, tElements, withTranslation]);

  return (
    <NotificationComponent
      id={id}
      title={translatedTitle}
      type={type}
      onClose={handleHide}
    />
  );
};

export default TranslatedNotification;
